export class StageVideoButtonComponent {
  private static stageVideoButtonComponentInstance: StageVideoButtonComponent;
  private static readonly stageVideoButton: string = '[data-js-video-button]';
  private static readonly playIcon: string = '[data-js-play-icon]';
  private static readonly pauseIcon: string = '[data-js-pause-icon]';
  private static readonly stageIframe: string = '[data-js-stageiframe]';
  private static readonly stageVideo: string = '.-hasBackgroundVideo video';
  private stageVideoPaused: boolean = false;

  public init(): void {
    window.addEventListener('load', this.setupEvents.bind(this));
  }

  public static get instance(): StageVideoButtonComponent {
    if (!StageVideoButtonComponent.stageVideoButtonComponentInstance) {
      StageVideoButtonComponent.stageVideoButtonComponentInstance = new StageVideoButtonComponent();
    }

    return StageVideoButtonComponent.stageVideoButtonComponentInstance;
  }

  private handleButtonClick(): void {
    const playIcon = document.querySelector(StageVideoButtonComponent.playIcon) as HTMLElement;
    const pauseIcon = document.querySelector(StageVideoButtonComponent.pauseIcon) as HTMLElement;
    const stageIframe = document.querySelector(StageVideoButtonComponent.stageIframe) as HTMLElement;
    const stageVideo = document.querySelector(StageVideoButtonComponent.stageVideo) as HTMLElement;
    const stageVideoButton = document.querySelector(StageVideoButtonComponent.stageVideoButton) as HTMLElement;

    this.stageVideoPaused = !this.stageVideoPaused;
    const isPaused = this.stageVideoPaused;
    const title = isPaused ? 'Hintergrundvideo abspielen' : 'Hintergrundvideo pausieren';
    stageVideoButton.setAttribute('title', title);
    stageVideoButton.setAttribute('aria-label', title);
    stageVideoButton.ariaPressed = isPaused;

    if (isPaused) {
      pauseIcon.setAttribute('display', 'none');
      playIcon.removeAttribute('display');
    } else {
      pauseIcon.removeAttribute('display');
      playIcon.setAttribute('display', 'none');
    }

    const command = isPaused ? 'pauseVideo' : 'playVideo';
    stageIframe?.contentWindow.postMessage(`{"event":"command","func":"${command}","args":""}`, '*');
    stageVideo?.[isPaused ? 'pause' : 'play']();
  }

  private setupEvents(): void {
    const { stageVideoButton } = StageVideoButtonComponent;
    const stopPauseButton = document.querySelectorAll(stageVideoButton);

    stopPauseButton.forEach((stopPauseButtons) => {
      stopPauseButtons.addEventListener('click', this.handleButtonClick.bind(this));
    });

  }
}
